import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import WhyUs from "@/pages/WhyUs";
import Steel from "@/pages/Steel";
import SteelSector from "@/pages/SteelSector";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const TITLES = {
  "/": "Premium Petroleum Solutions for Critical Industries",
  "/about": "About Us",
  "/products": "Petroleum Products",
  "/why-us": "Why Terra Bloom",
  "/contact": "Contact Us",
  "/privacy": "Privacy Policy",
};

const TitleManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const base = "Terra Bloom DWC LLC";
    document.title = TITLES[pathname] ? `${TITLES[pathname]} | ${base}` : `${base} — Petroleum Trading`;
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <TitleManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/steel" element={<Steel />} />
            <Route path="/steel/:slug" element={<SteelSector />} />
            <Route path="/why-us" element={<WhyUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
